module.exports = __webpack_public_path__ + "img/DCHQ-small.6d89f9ad.svg";